import { render, staticRenderFns } from "./TradingCentral.vue?vue&type=template&id=06694fd0&scoped=true"
import script from "./TradingCentral.vue?vue&type=script&lang=js"
export * from "./TradingCentral.vue?vue&type=script&lang=js"
import style0 from "./TradingCentral.vue?vue&type=style&index=0&id=06694fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06694fd0",
  null
  
)

export default component.exports